/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs */

const es_components_upgrade_plan_modal_plans_enterprise_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para compañías con necesidades de escala, gobernanza y uso intensivo.`)
};

const en_components_upgrade_plan_modal_plans_enterprise_description = /** @type {(inputs: Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For organizations that need scale, governance, and intensive usage.`)
};

/**
* | output |
* | --- |
* | "For organizations that need scale, governance, and intensive usage." |
*
* @param {Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_upgrade_plan_modal_plans_enterprise_description = /** @type {((inputs?: Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Upgrade_Plan_Modal_Plans_Enterprise_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_upgrade_plan_modal_plans_enterprise_description(inputs)
	return en_components_upgrade_plan_modal_plans_enterprise_description(inputs)
});
export { components_upgrade_plan_modal_plans_enterprise_description as "components.upgrade_plan_modal.plans.enterprise.description" }